import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSocket } from '../context/SocketProvider';
import AudioRecorderService from '../services/AudioRecorderService';

const VoiceClientPage = () => {
  const { SessionID } = useParams(); // Get SessionID from URL parameters
  const { sendAudio } = useSocket(); // Destructure sendAudio from context
  const [recording, setRecording] = useState(false);

  const handleStartRecording = async () => {
    try {
      await AudioRecorderService.startRecording();
      setRecording(true);
    } catch (err) {
      console.error('Error starting audio recording:', err);
    }
  };

  const handleStopRecording = async () => {
    try {
      const audioBlob = await AudioRecorderService.stopRecording();
      setRecording(false);

      console.log('Audio recorded:', audioBlob.size, 'bytes');

      try {
        console.log('Sending audio...', SessionID);
        sendAudio({ session_id: SessionID, audio_data: audioBlob, type: "chat" });
      } catch (error) {
        console.error('Request failed:', error);
        alert('Upload failed. Check console for details.');
      }
    } catch (err) {
      console.error('Error stopping audio recording:', err);
    }
  };

  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <h1>Voice Client</h1>
      <button
        style={{ width: '100%', height: '100%' }}
        onMouseDown={handleStartRecording}
        onMouseUp={handleStopRecording}
        onTouchStart={handleStartRecording}
        onTouchEnd={handleStopRecording}
      >
        {recording ? 'Recording...' : 'Hold to Record'}
      </button>
    </div>
  );
};

export default VoiceClientPage;